
(function loginDefinition() {
    'use strict';
    angular.module('Entities')
        .service('loginService', [
            'restUrlBuilder', 'config', function loginService(restUrlBuilder, config) {
                restUrlBuilder = restUrlBuilder('auth');

                this.getById = function getById(id, forEdit) {
                    if (angular.isUndefined(forEdit)) {
                        forEdit = true;
                    }

                    return restUrlBuilder.one('logins', 'logged')
                                         .get({
                                             params: {
                                                 forEdit: forEdit
                                             }
                                         });
                };

                this.get = function get(nickName, name, lastName, organizationalUnitId, completeName, identifier) {

                    var params = { NickName: nickName, FirstName: name, LastName: lastName, OrganizationalUnitId: organizationalUnitId, FullName: completeName, Identifier: identifier };

                    return restUrlBuilder.all('logins')
                        .get({ params: params });

                };

                this.getLogged = function getLogged() {
                    return restUrlBuilder.one('logins', 'logged')
                                         .get();
                };

                this.modify = function loginModify(login, profile) {
                    if (login == null)
                        throw "login no puede ser null";
                    return restUrlBuilder.all('logins')
                                         .put(login, { params: { profile: profile || false } });
                };

                this.setUser = function (userId) {
                    if (userId == null)
                        throw "UserId no puede ser null";
                    
                    return restUrlBuilder.one('logins/SetUser', userId).put();
                };

                this.setUserOu = function (ou) {
                    return restUrlBuilder.one('logins/SetOu', ou).put();
                };

            }
        ]);
})();